export default {
    name: "course_vertical_gridview",
    props: ["content", "md", "lg"],
    computed: {
        lgComputed() {
            if (this.lg != null && this.lg != 0) {
                return this.lg;
            }

            return 3;
        },
        mdComputed() {
            if (this.md != null && this.md != 0) {
                return this.md;
            }

            return 4;
        },
    },
    methods: {
        more() {
            const qs = this.$utility.queryStringToJson(
                this.content.footerButton
                    ? this.content.footerButton.queries
                    : this.content.headerButton.queries
            );
            this.$router.push({
                name: "course",
                query: qs,
            });
        },
        navigate(item) {
            this.$router.push({
                name: "course_detail",
                params: {
                    id: item._id,
                },
            });
        },
    },
};